<template>
  <div
    class="behance mt-3 d-flex flex-column align-items-center align-items-md-start justify-content-center gap-1 gap-md-3 position-relative group"
  >
    <img
      :src="behanceLogo"
      alt="behance logo"
      class="logo-img"
    />

    <div
      class="w-100 d-flex align-items-center justify-content-center justify-content-md-start gap-1 overflow-visible"
    >
      <p class="small text-white-90 mb-0 ps-3 ps-md-0">Case Study</p>
      <i class="bi bi-arrow-up-right text-white small ms-1 arrow-icon"></i>
    </div>
  </div>
</template>

<script>
import behanceLogo from "../../public/assets/client-image/behance.png";

export default {
  name: "Behance",
  data() {
    return {
      behanceLogo,
    };
  },
};
</script>

<style scoped>
.behance {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.logo-img {
  width: 65px;
  height: 12px;
}

@media (min-width: 992px) {
  .logo-img {
    width: 116px;
    height: 18px;
  }
}

.arrow-icon {
  transform: translateX(-10px);
  opacity: 0;
  transition: all 0.3s ease;
}

.behance:hover .arrow-icon {
  transform: translateX(0);
  opacity: 1;
}
</style>
